module.exports = __webpack_public_path__ + "img/selected2-min.031762d9.png";